/* GiurataTrad : refonte 2026-10 (maquette du 24/10/2026).
   Comportements des sections gt-* : en-tete, video du heros, configurateur de
   la fiche produit, calculette des prix, outil « quali documenti ».
   Le moteur d'achat du theme (theme.js, dt-uploader.js, dt-tracker) n'est pas
   modifie : on deplace des blocs existants dans une carte et on pilote le menu
   de variante d'origine, jamais l'inverse. */
(function () {
  'use strict';

  var SEP = ' → '; // format des valeurs de l'option « Lingua » (donnee, pas traduction)

  function lireJSON(el) {
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function formatPrezzo(cents, valuta) {
    var v = cents / 100;
    if (valuta === 'EUR') {
      var s = (v % 1 === 0) ? String(v) : v.toFixed(2).replace('.', ',');
      return s + ' €';
    }
    try { return new Intl.NumberFormat(document.documentElement.lang || 'it', { style: 'currency', currency: valuta }).format(v); }
    catch (e) { return v.toFixed(2) + ' ' + valuta; }
  }

  /* ---------- couples de langues : deux menus « da » / « verso » ----------
     valori : valeurs de variante disponibles, hors invite. Rend null si une
     valeur ne suit pas le format « A → B » : on garde alors le menu d'origine. */
  function analizzaCoppie(valori) {
    var da = [], verso = {}, ok = true;
    valori.forEach(function (v) {
      var parti = v.split(SEP);
      if (parti.length !== 2) { ok = false; return; }
      var a = parti[0].trim(), b = parti[1].trim();
      if (da.indexOf(a) < 0) da.push(a);
      (verso[a] = verso[a] || []).push(b);
    });
    return ok && da.length ? { da: da, verso: verso } : null;
  }

  function riempi(select, voci, invito) {
    select.innerHTML = '';
    var o = document.createElement('option');
    o.value = ''; o.textContent = invito; select.appendChild(o);
    voci.forEach(function (v) {
      var x = document.createElement('option');
      x.value = v; x.textContent = v; select.appendChild(x);
    });
  }

  /* ---------- en-tete (comportement de la maquette, assets/app.js) ----------
     Menus au survol sur ordinateur (130 ms d'attente a l'ouverture, 180 ms a la
     fermeture), au clic partout ; voile flou sous l'en-tete sauf pour la langue. */
  function initEntete() {
    var entete = document.querySelector('[data-gt-entete]');
    if (!entete) return;
    var boutons = Array.prototype.slice.call(entete.querySelectorAll('[data-gt-mega]'));
    var minuteur, attente, ouvertParSurvol = 0;
    function panneau(b) { return document.getElementById('gt-mega-' + b.getAttribute('data-gt-mega')); }
    function fermer() {
      boutons.forEach(function (x) { x.setAttribute('aria-expanded', 'false'); var m = panneau(x); if (m) m.removeAttribute('data-ouvert'); });
      document.body.classList.remove('gt-menu-ouvert');
    }
    function ouvrir(b) {
      clearTimeout(minuteur);
      fermer();
      var m = panneau(b); if (!m) return;
      m.setAttribute('data-ouvert', '');
      b.setAttribute('aria-expanded', 'true');
      document.body.classList.toggle('gt-menu-ouvert', b.getAttribute('data-gt-mega') !== 'lingua');
    }
    function fermerBientot() { clearTimeout(minuteur); minuteur = setTimeout(fermer, 180); }
    var survol = window.matchMedia('(hover: hover) and (min-width: 1081px)').matches;
    boutons.forEach(function (b) {
      var m = panneau(b);
      b.addEventListener('click', function (e) {
        e.stopPropagation();
        clearTimeout(attente);
        /* Un clic juste apres l'ouverture au survol confirme le menu au lieu de le refermer
           (le survol l'avait ouvert, le clic le fermait aussitot : bug signale par Sfar le 28/10/2026). */
        if (b.getAttribute('aria-expanded') === 'true' && Date.now() - ouvertParSurvol > 700) fermer(); else ouvrir(b);
      });
      if (survol) {
        b.addEventListener('mouseenter', function () {
          clearTimeout(attente);
          if (entete.querySelector('.gt-mega[data-ouvert]')) { ouvrir(b); ouvertParSurvol = Date.now(); } else attente = setTimeout(function () { ouvrir(b); ouvertParSurvol = Date.now(); }, 130);
        });
        b.addEventListener('mouseleave', function () { clearTimeout(attente); fermerBientot(); });
        if (m) { m.addEventListener('mouseenter', function () { clearTimeout(minuteur); }); m.addEventListener('mouseleave', fermerBientot); }
      }
    });
    document.addEventListener('click', function (e) { if (!(e.target.closest && e.target.closest('.gt-mega'))) fermer(); });

    /* recherche dans le menu des documents : mots sans accents, tous presents */
    var zone = entete.querySelector('[data-gt-recherche]');
    if (zone) {
      var champ = zone.querySelector('[data-gt-recherche-champ]');
      var liens = Array.prototype.slice.call(zone.querySelectorAll('[data-mots]'));
      var vide = zone.querySelector('.gt-docs-menu__vide');
      var plat = function (s) { return s.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase(); };
      var filtrer = function () {
        var mots = plat(champ.value).split(/\s+/).filter(Boolean), premier = null;
        liens.forEach(function (a) {
          var texte = plat(a.getAttribute('data-mots') + ' ' + a.textContent);
          var ok = mots.every(function (m) { return texte.indexOf(m) >= 0; });
          (a.closest('li') || a).hidden = !ok; a.classList.remove('gt-est-premier');
          if (ok && !premier && mots.length) premier = a;
        });
        zone.querySelectorAll('.gt-famille').forEach(function (f) { f.hidden = !f.querySelector('li:not([hidden])'); });
        var langues = zone.querySelector('.gt-docs-menu__langues');
        if (langues) langues.hidden = !langues.querySelector('a:not([hidden])');
        if (premier) premier.classList.add('gt-est-premier');
        if (vide) vide.hidden = !mots.length || !!premier;
        return premier;
      };
      champ.addEventListener('input', filtrer);
      champ.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); var a = filtrer(); if (a) location.href = a.href; } });
      champ.addEventListener('click', function (e) { e.stopPropagation(); });
    }

    /* tiroir mobile */
    var burger = entete.querySelector('[data-gt-burger]');
    var tiroir = document.getElementById('gt-tiroir');
    function basculer(ouvert) {
      if (!tiroir) return;
      tiroir.hidden = !ouvert;
      document.body.classList.toggle('gt-tiroir-ouvert', ouvert);
      burger.setAttribute('aria-expanded', ouvert ? 'true' : 'false');
      if (ouvert) { var f = tiroir.querySelector('[data-gt-fermer]'); if (f) f.focus(); } else { burger.focus(); }
    }
    if (burger && tiroir) {
      burger.addEventListener('click', function (e) { e.stopPropagation(); basculer(true); });
      tiroir.querySelector('[data-gt-fermer]').addEventListener('click', function () { basculer(false); });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      fermer();
      if (tiroir && !tiroir.hidden) basculer(false);
    });

    /* pastille du panier : theme.js n'en change que le texte, on la cache a 0 */
    var pastille = entete.querySelector('[data-cart-count]');
    if (pastille && window.MutationObserver) {
      var maj = function () { pastille.hidden = !(parseInt(pastille.textContent, 10) > 0); };
      new MutationObserver(maj).observe(pastille, { childList: true, characterData: true, subtree: true });
      maj();
    }
  }

  /* ---------- video du heros : ordinateur seulement ----------
     Sur telephone l'affiche reste une image : rien n'est telecharge. */
  function initVideo() {
    document.querySelectorAll('[data-gt-video]').forEach(function (fig) {
      var mp4 = fig.getAttribute('data-mp4'), webm = fig.getAttribute('data-webm');
      if (!mp4 && !webm) return;
      var grand = window.matchMedia('(min-width: 769px)').matches;
      var calme = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var eco = navigator.connection && navigator.connection.saveData;
      if (!grand || calme || eco) return;
      var img = fig.querySelector('img');
      var v = document.createElement('video');
      v.muted = true; v.loop = true; v.playsInline = true; v.autoplay = true;
      v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('preload', 'metadata');
      if (img) { v.poster = img.currentSrc || img.src; v.setAttribute('aria-label', img.alt); v.width = img.width; v.height = img.height; }
      if (webm) { var s1 = document.createElement('source'); s1.src = webm; s1.type = 'video/webm'; v.appendChild(s1); }
      if (mp4) { var s2 = document.createElement('source'); s2.src = mp4; s2.type = 'video/mp4'; v.appendChild(s2); }
      if (img) img.replaceWith(v); else fig.prepend(v);
      var b = fig.querySelector('[data-gt-video-bouton]');
      if (b) {
        b.hidden = false;
        b.addEventListener('click', function () {
          if (v.paused) { v.play(); b.classList.remove('is-ferme'); b.setAttribute('aria-label', b.getAttribute('data-label-pausa')); }
          else { v.pause(); b.classList.add('is-ferme'); b.setAttribute('aria-label', b.getAttribute('data-label-play')); }
        });
      }
      var p = v.play(); if (p && p.catch) p.catch(function () {});
    });
  }

  /* ---------- fiche produit ---------- */
  function initConfig() {
    var carte = document.querySelector('[data-gt-config]');
    if (!carte) return;
    var dati = lireJSON(carte.querySelector('[data-gt-config-dati]')) || {};
    var details = carte.closest('.productView-details') || document;
    function blocDe(sel) { var el = details.querySelector(sel); return el ? (el.closest('.productView-moreItem') || el) : null; }
    var place = function (slot, el) { var s = carte.querySelector('[data-gt-slot="' + slot + '"]'); if (s && el) s.appendChild(el); };

    var blocVariante = details.querySelector('.productView-moreItem-product-variant');
    var blocUpload = details.querySelector('.dt-uploader');
    var blocQuantite = blocDe('.productView-quantity.quantity__group--2') || blocDe('.productView-quantity:not(.hidden)');
    var blocBoutons = blocDe('.productView-buttons');
    place('lingua', blocVariante);
    place('pagine', blocQuantite);
    place('documento', blocUpload);
    place('bottoni', blocBoutons);
    carte.classList.add('gt-config--pret');

    /* menus da / verso */
    var origine = blocVariante && blocVariante.querySelector('select[name^="options["]');
    var paire = carte.querySelector('[data-gt-paire]');
    if (origine && paire) {
      var invite = origine.querySelector('option[data-placeholder="true"]');
      var valori = [];
      Array.prototype.forEach.call(origine.options, function (o) { if (o !== invite) valori.push(o.value); });
      var coppie = analizzaCoppie(valori);
      if (coppie) {
        var selDa = paire.querySelector('[data-gt-da]'), selVerso = paire.querySelector('[data-gt-verso]');
        var scegli = paire.getAttribute('data-scegli');
        riempi(selDa, coppie.da, scegli);
        riempi(selVerso, [], scegli); selVerso.disabled = true;
        var conteneur = origine.closest('.product-form__input') || origine;
        conteneur.classList.add('gt-cache'); conteneur.setAttribute('data-gt-select-origine', '');
        paire.hidden = false;
        var applica = function (valore) {
          if (origine.value === valore) return;
          origine.value = valore;
          origine.dispatchEvent(new Event('change', { bubbles: true }));
        };
        selDa.addEventListener('change', function () {
          var lista = coppie.verso[selDa.value] || [];
          riempi(selVerso, lista, scegli);
          selVerso.disabled = !lista.length;
          if (lista.length === 1) { selVerso.value = lista[0]; }
          if (selDa.value && selVerso.value) applica(selDa.value + SEP + selVerso.value);
          else if (invite) applica(invite.value);
        });
        selVerso.addEventListener('change', function () {
          if (selDa.value && selVerso.value) applica(selDa.value + SEP + selVerso.value);
          else if (invite) applica(invite.value);
        });
        /* variante deja choisie (lien ?variant=) */
        var sel = origine.options[origine.selectedIndex];
        if (sel && sel !== invite && sel.value.indexOf(SEP) > 0) {
          var p = sel.value.split(SEP);
          selDa.value = p[0].trim(); selDa.dispatchEvent(new Event('change'));
          selVerso.value = p[1].trim();
        }
      }
    }

    /* document (page de commande generique) : propriete de ligne nommee seulement
       quand un document est choisi ; theme.js envoie les champs
       .line-item-property__field [name^="properties"] avec l'article */
    var documento = carte.querySelector('[data-gt-documento]');
    if (documento) {
      documento.addEventListener('change', function () {
        if (documento.value) documento.name = 'properties[' + documento.getAttribute('data-proprieta') + ']';
        else documento.removeAttribute('name');
      });
    }

    /* total : prix de la variante x pages + option */
    var totale = carte.querySelector('[data-gt-totale]');
    var copia = carte.querySelector('[data-gt-copia]');
    var formulaire = document.querySelector('form[id^="product-form-"]:not([id*="installment"]):not([id*="sticky"])');
    function quantite() {
      var q = blocQuantite && blocQuantite.querySelector('input[name="quantity"]');
      var n = q ? parseInt(q.value, 10) : 1;
      return n > 0 ? n : 1;
    }
    function varianteId() {
      var i = formulaire && formulaire.querySelector('[name="id"]');
      return i ? String(i.value) : '';
    }
    function aggiorna() {
      if (!totale) return;
      var prezzo = (dati.prezzi && dati.prezzi[varianteId()]) || dati.prezzo_base || 0;
      var t = prezzo * quantite() + (copia && copia.checked ? (dati.copia_prezzo || 0) : 0);
      totale.textContent = formatPrezzo(t, dati.valuta || 'EUR');
    }
    var differe = function () { setTimeout(aggiorna, 60); };
    carte.addEventListener('change', differe);
    carte.addEventListener('input', differe);
    carte.addEventListener('click', differe);
    aggiorna();

    /* option copie papier : ajoutee au panier AVANT l'article, puis le clic
       d'origine est rejoue pour que le theme fasse son ajout et sa redirection.
       Ecoute en capture, enregistree apres le garde-fou du televerseur : un clic
       qu'il a refuse (defaultPrevented) n'ajoute rien. */
    if (copia && dati.copia_id) {
      var rejeu = false;
      var brancher = function () {
        document.addEventListener('click', function (e) {
          var btn = e.target && e.target.closest && e.target.closest('[name="add"]');
          if (!btn || rejeu || !copia.checked || e.defaultPrevented) return;
          if (!btn.closest('form[action$="/cart/add"]')) return;
          var choix = origine && origine.options[origine.selectedIndex];
          if (choix && choix.getAttribute('data-placeholder') === 'true') return;
          e.preventDefault(); e.stopImmediatePropagation();
          var racine = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          var erreur = carte.querySelector('[data-gt-erreur]');
          /* /cart/update.js et non /cart/add.js : le traqueur (snippets/dt-tracker.liquid)
             compte chaque /cart/add comme un add_to_cart ; l'option ne doit pas en ajouter
             un second. update met la copie a 1 (l'ajoute si absente, idempotent sinon) en
             un seul aller-retour, pour que l'ajout de l'article parte vite apres le clic. */
          var maj = {}; maj[dati.copia_id] = 1;
          fetch(racine + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ updates: maj })
          })
            .then(function (r) { if (!r.ok) throw new Error('update ' + r.status); })
            .catch(function () { if (erreur) erreur.hidden = false; })
            .then(function () {
              rejeu = true;
              btn.click();
              setTimeout(function () { rejeu = false; }, 4000);
            });
        }, true);
      };
      if (document.readyState === 'complete') brancher();
      else window.addEventListener('load', brancher);
    }
  }

  /* ---------- calculette des prix ---------- */
  function initCalcolo() {
    document.querySelectorAll('[data-gt-calcolo]').forEach(function (box) {
      var d = lireJSON(box.querySelector('[data-gt-calcolo-dati]')) || {};
      var pagine = box.querySelector('[data-gt-pagine]');
      var copia = box.querySelector('[data-gt-copia]');
      var out = box.querySelector('[data-gt-totale]');
      function calc() {
        var n = Math.max(1, parseInt(pagine.value, 10) || 1);
        out.textContent = formatPrezzo(n * (d.prezzo || 0) + (copia && copia.checked ? (d.copia || 0) : 0), d.valuta || 'EUR');
      }
      box.addEventListener('input', calc); box.addEventListener('change', calc); calc();
    });
  }

  /* ---------- pas +/- generiques ---------- */
  function initPas(root) {
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-gt-pas]');
      if (!b) return;
      var input = b.parentNode.querySelector('input');
      var n = (parseInt(input.value, 10) || 1) + Number(b.getAttribute('data-gt-pas'));
      input.value = Math.max(1, Math.min(99, n));
      input.dispatchEvent(new Event('input', { bubbles: true }));
    });
  }

  /* ---------- outil « quali documenti » ---------- */
  function initOutil() {
    var outil = document.querySelector('[data-gt-outil]');
    if (!outil) return;
    var d = lireJSON(outil.querySelector('[data-gt-outil-dati]')) || {};
    var lignes = Array.prototype.slice.call(outil.querySelectorAll('[data-gt-doc]'));
    var listePratica = outil.querySelector('[data-gt-lista-pratica]');
    var listeAltri = outil.querySelector('[data-gt-lista-altri]');
    var selDa = outil.querySelector('[data-gt-da]'), selVerso = outil.querySelector('[data-gt-verso]');
    var scegli = selDa.getAttribute('data-scegli');
    var coppie = analizzaCoppie(d.coppie || []);
    if (coppie) { riempi(selDa, coppie.da, scegli); riempi(selVerso, [], scegli); selVerso.disabled = true; }
    selDa.addEventListener('change', function () {
      var l = (coppie && coppie.verso[selDa.value]) || [];
      riempi(selVerso, l, scegli); selVerso.disabled = !l.length;
      if (l.length === 1) selVerso.value = l[0];
      aggiorna();
    });
    selVerso.addEventListener('change', aggiorna);
    outil.querySelectorAll('input[name="gt-pratica"]').forEach(function (r) {
      r.addEventListener('change', function () {
        var membri = (d.pratiche && d.pratiche[r.value]) || [];
        lignes.forEach(function (l) {
          var dentro = membri.indexOf(l.getAttribute('data-gt-doc')) >= 0;
          (dentro ? listePratica : listeAltri).appendChild(l);
          l.querySelector('input[type="checkbox"]').checked = dentro;
        });
        listePratica.closest('[data-gt-bloc-pratica]').hidden = !membri.length;
        aggiorna();
      });
    });
    outil.addEventListener('input', aggiorna);
    outil.addEventListener('change', function (e) { if (e.target.type === 'checkbox') aggiorna(); });
    initPas(outil);

    var resume = outil.querySelector('[data-gt-resume]');
    var vide = outil.querySelector('[data-gt-resume-vuoto]');
    var tot = outil.querySelector('[data-gt-totale]');
    var aviso = outil.querySelector('[data-gt-scegli-lingua]');
    function aggiorna() {
      var coppia = selDa.value && selVerso.value ? selDa.value + SEP + selVerso.value : '';
      var somma = 0; resume.innerHTML = '';
      lignes.forEach(function (l) {
        var h = l.getAttribute('data-gt-doc');
        var info = (d.prodotti || {})[h] || {};
        var n = Math.max(1, parseInt(l.querySelector('[data-gt-pagine]').value, 10) || 1);
        var link = l.querySelector('[data-gt-link]');
        var vid = coppia && info.varianti ? info.varianti[coppia] : null;
        link.href = info.url + (vid ? '?variant=' + vid : '');
        if (l.querySelector('input[type="checkbox"]').checked) {
          somma += n * (info.prezzo || 0);
          var li = document.createElement('li');
          var a = document.createElement('span'); a.textContent = info.nome + ' × ' + n;
          var b = document.createElement('span'); b.textContent = formatPrezzo(n * (info.prezzo || 0), d.valuta || 'EUR');
          li.appendChild(a); li.appendChild(b); resume.appendChild(li);
        }
      });
      vide.hidden = resume.children.length > 0;
      tot.textContent = formatPrezzo(somma, d.valuta || 'EUR');
      if (aviso) aviso.hidden = !!coppia;
    }
    aggiorna();
  }

  /* ---------- sommaire d'un guide : les h2 du texte ---------- */
  function initSommaire() {
    var corps = document.querySelector('[data-gt-article]');
    var boite = document.querySelector('[data-gt-sommaire]');
    if (!corps || !boite) return;
    var liste = boite.querySelector('ol');
    var titres = Array.prototype.slice.call(corps.querySelectorAll('h2'));
    if (titres.length < 2) return;
    titres.forEach(function (h, i) {
      if (!h.id) h.id = 'gt-s' + (i + 1);
      var li = document.createElement('li'), a = document.createElement('a');
      a.href = '#' + h.id; a.textContent = h.textContent.trim();
      li.appendChild(a); liste.appendChild(li);
    });
    boite.hidden = false;
    if (!window.IntersectionObserver) return;
    var liens = liste.querySelectorAll('a');
    var obs = new IntersectionObserver(function (entrees) {
      entrees.forEach(function (e) {
        if (!e.isIntersecting) return;
        liens.forEach(function (a) { a.setAttribute('aria-current', a.getAttribute('href') === '#' + e.target.id ? 'true' : 'false'); });
      });
    }, { rootMargin: '0px 0px -70% 0px' });
    titres.forEach(function (h) { obs.observe(h); });
  }

  /* ---------- barre collante de la fiche (telephone) ---------- */
  function initBarre() {
    var barre = document.querySelector('[data-gt-barre]');
    if (!barre) return;
    var cible = document.querySelector('.gt-config [name="add"]') || document.querySelector('#gt-commande') || document.querySelector('h1');
    var maj = function (visible) { barre.hidden = visible; document.body.classList.toggle('gt-a-barre', !visible); };
    if (window.IntersectionObserver && cible) {
      new IntersectionObserver(function (es) { maj(es[0].isIntersecting); }, { threshold: 0 }).observe(cible);
    } else { maj(false); }
  }

  function init() {
    initEntete(); initVideo(); initConfig(); initCalcolo(); initOutil(); initSommaire(); initBarre();
    document.querySelectorAll('[data-gt-calcolo]').forEach(initPas);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
